export function calculateDiffInYear(dateString) {
  // Parse the date string into a Date object
  const birthDate = new Date(dateString);

  // Check if the date is valid
  if (isNaN(birthDate)) {
    throw new Error("Invalid date format");
  }

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  console.log(today.getFullYear(), birthDate.getFullYear())

  // Adjust if the birthday hasn't occurred yet this year
  const monthDifference = today.getMonth() - birthDate.getMonth();
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}


//calculate the months between today date and given date
export function calculateDiffInMonth(dateString) {
  // Parse the date string into a Date object
  const birthDate = new Date(dateString);

  // Check if the date is valid
  if (isNaN(birthDate)) {
    throw new Error("Invalid date format");
  }

  const today = new Date();

  // Calculate the total difference in years and months
  const yearDifference = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  // Calculate the total months difference
  let totalMonths = yearDifference * 12 + monthDifference;

  // Adjust if the current day is less than the birth day
  if (today.getDate() < birthDate.getDate()) {
    totalMonths--;
  }

  console.log(totalMonths)

  return totalMonths;
}

export function calculateAgeInDays(args) {

  // Split only on the outer comma between the two dates
  const parts = args.split(/'\s*,\s*'/).map(str => str.replace(/'/g, "").trim());

  if (parts.length < 2) {
    throw new Error("Please provide two dates separated by a comma");
  }

  const dob = parts[0];
  const admissionDate = parts[1];

  const birthDate = new Date(dob);
  const admitDate = new Date(admissionDate);

  if (isNaN(birthDate) || isNaN(admitDate)) {
    throw new Error("Invalid date format");
  }

  const diffInMs = admitDate - birthDate;
  const ageInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return Math.abs(ageInDays);
}

/**
 * takes input string with string to split 
 * seperator and index numbers
 * @param {*} inputStr 
 * @returns concatinated string 
 */
export function splitDataAndConcat(inputStr) {
  // Parse the inputs
  const [rawString, rawSeparator, rawIndexes] = inputStr.split(/,(?![^\[]*\])/); // Handles array comma safely

  const str = rawString.trim().replace(/^'|'$/g, ''); // remove quotes
  const separator = rawSeparator.trim().replace(/^'|'$/g, '').trim();
  const indexes = JSON.parse(rawIndexes.trim()); // parse [0,2] into array

  // Split and extract
  const parts = str.split(separator);
  console.log(str, parts, separator, indexes)
  return indexes.map(i => parts[i]).join(' ');
}

//fucntionto return current date
export function autofillcurrentDate() {
  return new Date();
}


//funciton to calculate BMI
export function fillBMIGroup(height) {
  console.log("height", height)
  height = height.replaceAll(`'`, "");
  let heightInMeters = parseFloat(height.split(',')[0]) / 100;
  let bmiValue = parseFloat(height.split(',')[1]) / (heightInMeters * heightInMeters);
  bmiValue = bmiValue.toFixed(2);
  console.log("bmiValue", bmiValue)
  if (bmiValue < 23) {
    return { label: 'Normal', value: 'Normal' };
  } else if (bmiValue >= 23 && bmiValue < 25) {
    return { label: 'Overweight', value: 'Overweight' };
  } else if (bmiValue >= 25 && bmiValue <= 27.5) {
    return { label: 'Obese', value: 'Obese' };
  } else {
    return { label: 'Morbid Obese', value: 'Morbid Obese' };
  }
}

export function fillWaistGroup(waistinfo) {
  let genderWaist = waistinfo.replaceAll(`'`, "");
  let gender = genderWaist.split(',')[0].trim();
  let waistCircum = parseFloat(genderWaist.split(',')[1]);
  console.log("waistValue", gender, waistCircum)
  if (gender == "Male" && waistCircum >= 36) {
    return { label: 'High', value: 'High' };
  } else if (gender == "Male" && waistCircum < 36) {
    console.log("waistValue", gender, waistCircum, genderWaist)

    return { label: 'Normal', value: 'Normal' };
  } else if (gender == "Female" && waistCircum >= 32) {
    return { label: 'High', value: 'High' };
  } else if (gender == "Female" && waistCircum < 32) {
    return { label: 'Normal', value: 'Normal' };
  }
}

export function sumationOfFieldValues(values) {
  console.log("sumation values:,", values);

  // Split by comma
  const arr = values.split(',');

  // Remove single quotes, trim, convert to number and handle NaN as 0
  const sum = arr.reduce((acc, val) => {
    const cleaned = val.replace(/'/g, '').trim();
    const num = Number(cleaned);
    return acc + (isNaN(num) ? 0 : num);
  }, 0);

  return sum;
}
